<template>
  <div class="row justify-left no-wrap">
    <q-toggle
      v-model="element.Positive"
      checked-icon="add"
      color="navy"
      label=""
      size="xs"
      unchecked-icon="remove"
    />
    <div :class="['q-my-none', 'q-pt-xs', { 'text-grey-8': !element.Entity }]">
      {{ getElementName }}
    </div>
  </div>
  <q-btn
    class="q-px-none q-mx-none q-mt-xs unset-items-center"
    flat
    dense
    :aria-label="$t('delete_filter')"
    icon="close"
    size="sm"
    tabindex="-1"
    color="accent"
    @click="deleteItem"
  >
    <q-tooltip :delay="300" anchor="top middle" self="center middle">
      {{ $t("remove") }}
    </q-tooltip>
  </q-btn>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from "vue-facing-decorator";
import { SelectionEntityWithRolesFilterSend } from "@/models/interfaces/entity-settings/filters/filters";

@Component({
  name: "EWRItemElement",
})
export default class EWRItemElement extends Vue {
  @Prop({ default: {} as SelectionEntityWithRolesFilterSend })
  element!: SelectionEntityWithRolesFilterSend;

  @Emit("itemDeleted") emitDeleteItem(arg: number) {
    return arg;
  }

  @Prop({ default: false })
  isRoot!: boolean;

  @Prop({ default: undefined })
  parentId!: number | undefined;
  @Prop({ default: undefined })
  parentIdx!: string | undefined;
  @Prop({ default: "" })
  parentName!: string;
  @Prop({ default: -1 })
  inputIndex!: number;

  // temporary data
  tempName: string = "";

  created() {
    //
  }

  get getElementName(): string {
    return this.element.Entity.Name;
  }

  deleteItem() {
    this.emitDeleteItem(this.inputIndex);
  }
}
</script>

<style lang="scss">
// .minw-element-element {
//   font-size: small !important;
// }

.text-filter-item {
  &--child {
    margin-left: 26px !important;
  }
}
</style>
